<script>
import NoLocation from "@/view/components/lpm/wizard-steps/NoLocation.vue";
import MaxBudgetDetail from "@/view/components/lpm/wizard-steps/MaxBudgetDetail.vue";

export default {
  name: "max-budget",
  components: {
    NoLocation,
    MaxBudgetDetail
  },
  data() {
    return {
      locations: [],
      options: [
        {
          text: "Spend My Campaign Budget Across All Selected Stores",
          value: "all store"
        },
        {
          text: "Spend My Campaign Budget Across Each Store Differently",
          value: "per store"
        }
      ],
      form: {
        selectedSpend: null,
        max_campaign_budget: null,
        max_monthly_budget: null
      }
    };
  },
  computed: {
    getLocations() {
      return this.$store.getters["getLpmLocations"];
    }
  },
  watch: {
    getLocations(newVal) {
      this.locations = newVal;
    }
  },
  methods: {
    handleMaxCampaignBudget() {
      this.form.max_monthly_budget = null;
    },
    handleMaxMonthlyBudget() {
      this.form.max_campaign_budget = null;
    }
  }
};
</script>

<template>
  <div>
    <p>
      You can choose to run a campaign budget per-store, or across all stores.
      In either case you can choose a start and end date with a maximum budget
      to be spent between those dates, OR choose a maximum monthly spend.
    </p>
    <p>
      If you don't want an end date on a campaign, just leave the End Date field
      empty and tell us your maximum monthly budget. You can cancel the campaign
      whenever you'd like by finding it on the Campaigns page.
    </p>
    <no-location v-if="locations.length === 0"></no-location>
    <div v-if="locations.length > 0">
      <b-form-group class="text-center" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          name="selectedSpend"
          v-model="form.selectedSpend"
          :options="options"
          :aria-describedby="ariaDescribedby"
          button-variant="outline-primary"
          size="lg"
          buttons
        ></b-form-radio-group>
      </b-form-group>
      <v-card
        v-if="form.selectedSpend === 'all store'"
        class="mx-auto mb-5 p-5"
        max-width="700"
      >
        <b-row>
          <b-col cols="12">
            <b-row class="mb-n5">
              <b-col>
                <b-form-group label="Maximum Campaign Budget">
                  <b-form-input
                    id="max_campaign_budget"
                    v-model="form.max_campaign_budget"
                    type="number"
                    required
                    placeholder="$0.00"
                    @change="handleMaxCampaignBudget"
                    @keyup="handleMaxCampaignBudget"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="text-center font-weight-bold" cols="4">
                <h2>OR</h2>
              </b-col>
              <b-col>
                <b-form-group label="Maximum Monthly Budget">
                  <b-form-input
                    id="max_monthly_budget"
                    v-model="form.max_monthly_budget"
                    type="number"
                    required
                    placeholder="$0.00"
                    @change="handleMaxMonthlyBudget"
                    @keyup="handleMaxMonthlyBudget"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </v-card>
      <v-card
        v-if="form.selectedSpend === 'per store'"
        class="mx-auto mb-5 p-5"
        max-width="700"
      >
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">
                Location
              </th>
              <th class="text-left">
                Maximum Campaign Budget
              </th>
              <th class="text-left">
                Maximum Monthly Budget
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in locations">
              <max-budget-detail
                :key="item.id"
                :item="item"
              ></max-budget-detail>
            </template>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </div>
</template>
